import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconFilter = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.08482 5.57912C5.23443 5.22596 5.55758 5 5.91305 5H18.0869C18.4424 5 18.7656 5.22596 18.9152 5.57912C19.0648 5.93229 19.0137 6.34845 18.7841 6.64572L14.1304 12.6728V18C14.1304 18.3466 13.9666 18.6684 13.6974 18.8506C13.4282 19.0329 13.0921 19.0494 12.8091 18.8944L10.3743 17.5611C10.065 17.3917 9.86957 17.0454 9.86957 16.6667V12.6728L5.21588 6.64573C4.98635 6.34845 4.93521 5.93229 5.08482 5.57912ZM7.88094 7L11.4798 11.6609C11.6192 11.8415 11.6957 12.0702 11.6957 12.3067V16.0486L12.3043 16.382V12.3067C12.3043 12.0702 12.3808 11.8415 12.5202 11.6609L16.1191 7H7.88094Z"
        />
      </svg>
    );
  }
);
